module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_vm._v("Bachelors I")]), _vm._v(" "), _c('p', {
    staticClass: "BT-Opener"
  }, [_c('span', {
    staticClass: "Drop CharOverride-9"
  }, [_vm._v("H")]), _vm._v("e’s moved into a basement apartment in Vesturbær on the west side of town with a friend who is the very embodiment of a tragic bachelor. His roommate can’t even take care of himself—he’s at least thirty, but he hasn’t learned how to wash his clothes properly. He just leaves his wet clothes in the machine until they dry. The place is a cesspool. Their towels are all sour, and the smell gets pretty pungent when you dry off. And his roommate doesn’t cook, either. On a good day, he might boil a hot dog, but he seems to live on bodega burgers, chocolate chip cookies, and Diet Coke. He’s crazy about Diet Coke; in the morning, he shuffles out of his room in a sloppy navy bathrobe and the first thing he does is swig flat Coke from the bottle. I don’t understand how he can live with this guy. But it’s nice to be able to hang out by ourselves. We aren’t together, but I’m with him all the time. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a48892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802157409-6.vue
// module id = 81
// module chunks = 0